import { type AtHomeDeliveryShippingMethod } from "@jti/commerce";
import type { SectionState } from "@jti/store/slices/checkoutV2Slice";

export const MAGENTO_PAYMENT_METHOD_COMMON = "jtipayment";
export const MAGENTO_PAYMENT_METHOD_PAY_ON_DELIVERY = "cashondelivery";

export const PAYMENT_ADAPTER_MOUNT_NODE_ID = "payment-adapter-mount-point";

export const COLLAPSIBLE_SECTION_OPEN_STATE: SectionState[] = ["active", "editing"];

export const DEFAULT_AT_HOME_SHIPPING_METHOD: AtHomeDeliveryShippingMethod = {
  type: "atHome",
  methodCode: "atHome",
  label: "",
};
